export default class PaymentPortal {
	public PortalLink: string = '';
	public Created: string = '';
}
